import React from 'react';
import ReactConfetti from 'react-confetti';

export default function CelebrationConfetti(props) {
  return <ReactConfetti recycle={false} numberOfPieces={200} gravity={0.3} {...props} />;
}
